"use strict";
var __decorate = (this && this.__decorate) || function (decorators, target, key, desc) {
    var c = arguments.length, r = c < 3 ? target : desc === null ? desc = Object.getOwnPropertyDescriptor(target, key) : desc, d;
    if (typeof Reflect === "object" && typeof Reflect.decorate === "function") r = Reflect.decorate(decorators, target, key, desc);
    else for (var i = decorators.length - 1; i >= 0; i--) if (d = decorators[i]) r = (c < 3 ? d(r) : c > 3 ? d(target, key, r) : d(target, key)) || r;
    return c > 3 && r && Object.defineProperty(target, key, r), r;
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.AlissasLinkAbilityHandler = exports.AlissasLinkActorAbilityFactory = exports.AlissasLinkAbilityArgs = void 0;
const AbilityType_1 = require("../../core/abilities/AbilityType");
const ActorAbilityState_1 = require("../../core/actors/ActorAbilityState");
const Duration_1 = require("../../core/Duration");
const SplitDamageReflect_1 = require("../../core/effects/core/SplitDamageReflect");
const Registries_1 = require("../../core/state/Registries");
const Target_1 = require("../../core/Target");
class AlissasLinkAbilityArgs {
    constructor(target) {
        this.target = target;
        this.__type = AbilityType_1.AbilityType.AlissasLink;
        this.__typeName = "AlissasLink";
    }
}
exports.AlissasLinkAbilityArgs = AlissasLinkAbilityArgs;
let AlissasLinkActorAbilityFactory = class AlissasLinkActorAbilityFactory {
    mk() {
        return new ActorAbilityState_1.ActorAbilityState("AlissasLink", "AllAllies", 5);
    }
};
AlissasLinkActorAbilityFactory = __decorate([
    Registries_1.ActorAbilities.register("AlissasLink")
], AlissasLinkActorAbilityFactory);
exports.AlissasLinkActorAbilityFactory = AlissasLinkActorAbilityFactory;
let AlissasLinkAbilityHandler = class AlissasLinkAbilityHandler {
    init(sequence, container, actorId) { }
    activate(sequence, container, ability) {
        sequence = sequence.pushSequence("parallel");
        // TODO: Refactor
        const allies = ability.args.target.actorIds;
        const enemies = container.selectLivingTargets(ability.invokerId, Target_1.Target.AllEnemies);
        for (const ally of allies) {
            container.applyBuff({
                sequence,
                creatorId: ability.invokerId,
                targetId: ally,
                effect: new SplitDamageReflect_1.SplitDamageReflectEffectArgs(ability.invokerId, enemies),
                duration: Duration_1.Duration.Turns(4),
            });
        }
    }
};
AlissasLinkAbilityHandler = __decorate([
    Registries_1.Abilities.register(AbilityType_1.AbilityType.AlissasLink)
], AlissasLinkAbilityHandler);
exports.AlissasLinkAbilityHandler = AlissasLinkAbilityHandler;
